// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2816":"4aa58a79","4454":"4ba77980"}[chunkId] + ".chunk.css";
};